import * as React from "react";
import { Logger } from "../util/Logger";
import Header from "./HeaderComponent";
import StationName from "./StationNameComponent"
import Fullscreen from "./FullScreenComponent"
import DepartureHeader from "./DepartureHeaderComponent"
import { GenericConfig } from "../GenericConfig";
import { DepartureComponent } from "./DepartureComponent";
import { Board, BoardEntry } from "../controllers/model/api";
import { HelperFunctions } from "../util/HelperFunctions";
import GlobalConfiguration from "../controllers/model/GlobalConfiguration";
import moment from 'moment'

const sourceFileName = "DepartureBoard.tsx";

export interface DepartureBoardProps {
    departureBoard: Board;
    product?:number;
}

export class DepartureBoardComponent extends React.Component<DepartureBoardProps, {}> {
    private fontcolor: string = "";
    //#region Render
    public render() {
        Logger.debug(sourceFileName, "rendering app component");
        var stationname = "";
        var deptOnNextDay:boolean = false;
        if (HelperFunctions.checkForNullOrEmpty(this.props.departureBoard.stationName))
            stationname = this.props.departureBoard.stationName;
        if(this.checkForFullscreenMessage(this.props.departureBoard.infoHeader,this.props.departureBoard.infoText)){
            this.props.departureBoard.infoHeader = this.props.departureBoard.infoHeader.replace("!!","");
            return(
                <div>
                    <Header></Header>
                    <StationName product={this.props.product} stationname={stationname}></StationName>
                    <DepartureHeader></DepartureHeader>
                    <Fullscreen headerText={this.props.departureBoard.infoHeader} infoText={this.props.departureBoard.infoText}></Fullscreen>
                </div>
            )
        }
        return (

            <div id="departureBoard">
                <Header />
                <StationName product={this.props.product} stationname={stationname}></StationName>
                <DepartureHeader></DepartureHeader>
                {[...new Array(GenericConfig.Lines())].map((x, rowIndex) => {
                    if(rowIndex === 0 && new Date(Date.now()).toDateString() !== new Date(Date.parse(this.props.departureBoard.entries[0].date)).toDateString()){
                        var stringDate1 = moment(this.props.departureBoard.entries[0].date, "YYYY-MM-DD");
                        this.props.departureBoard.entries.splice(0,0,HelperFunctions.createNewBoardEntry(GlobalConfiguration.NextDepartureOn+stringDate1.format("DD.MM.YYYY")));
                    }
                    else if(!deptOnNextDay)
                        deptOnNextDay = this.checkForDeparturesNextDay(rowIndex);
                    else
                        deptOnNextDay = false;
                    return (
                        this.renderDeparture(rowIndex)
                    )
                })
                }
            </div>
        );
    }
    checkForFullscreenMessage(pInfoHeader:string,pInfoText:string){
        if(HelperFunctions.checkForNullOrEmpty(pInfoHeader)&& pInfoHeader.includes("!!"))
            return true;
        if(HelperFunctions.checkForNullOrEmpty(pInfoText)&&pInfoText.includes("!!"))
            return true;
        return false;
    }
    checkForDeparturesNextDay(i:number){ 
        if(i+1 === GenericConfig.Lines()-1 || this.props.departureBoard.entries[i+1] === undefined)
            return false;
        if(this.props.departureBoard.entries[i].date !== this.props.departureBoard.entries[i+1].date){
            var stringDate = moment(this.props.departureBoard.entries[i+1].date, "YYYY-MM-DD");
            this.props.departureBoard.entries.splice(i+1,0,HelperFunctions.createNewBoardEntry(GlobalConfiguration.NextDepartureOn+stringDate.format("DD.MM.YYYY")));
            return true;
        }
        return false;
    }
    renderDeparture(i: number) {
        if (this.props.departureBoard.entries[i] === undefined)
            return;
        let departure = this.props.departureBoard.entries[i];
        this.replaceEstimatedTimeIfEqualToTime(departure); //replace estimated time with empty string if it is equal to time
        let backgroundColor = this.getBackgroundColor(departure, i); //get background color from row
        let stationMessage = "";
        if ((i === GenericConfig.Lines() - 1 || 
             i === this.props.departureBoard.entries.length - 1) &&
             HelperFunctions.checkForNullOrEmpty(this.props.departureBoard.infoText)){ 
            stationMessage = this.props.departureBoard.infoText;
            backgroundColor = "white";
        }
        if (this.props.departureBoard.entries[i].direction === GlobalConfiguration.NoMoreDepartures)
                stationMessage = GlobalConfiguration.NoMoreDepartures;
            if(this.props.departureBoard.entries[i].direction.startsWith(GlobalConfiguration.NextDepartureOn)){
                stationMessage = this.props.departureBoard.entries[i].direction;
                backgroundColor = this.getAlternateRowColor(i);
        }
            return (
                <DepartureComponent key={i}
                    backgroundColor={backgroundColor} departure={departure}
                    fontcolor={this.fontcolor} stationInfoLine={stationMessage} />
            );
        
    }
    //#endregion

    //#region Background
    getBackgroundColor(pDeparture: BoardEntry, index: number) {
        //use linedeparturecolor, if not available use alternate row color
        let lineDeparturebackgroundColor = this.getLineDepartureColor(pDeparture);
        if (lineDeparturebackgroundColor !== null)
            return lineDeparturebackgroundColor;
        else
            return this.getAlternateRowColor(index);
    }
    getAlternateRowColor(i: number) {
        if (i % 2 !== 0) {
            return "#D3D3D3";
        }
        else
            return "white";
    }
    getLineDepartureColor(pDeparture: BoardEntry) {
        pDeparture.date = pDeparture.date.substring(0, 10);
        let departureDate: number;
        if (HelperFunctions.checkForNullOrEmpty(pDeparture.timeProg))
            departureDate = Date.parse(pDeparture.date + ":" + pDeparture.timeProg);
        else
            departureDate = Date.parse(pDeparture.date + ":" + pDeparture.time);
        if (Date.now() >= departureDate) {
            this.fontcolor = "white"
            return "#ba4040"
        }
        // yellow if departure is in 2 minutes
        // not needed anymore, because of customer requirement 30.01.2024
        // WHY IS THIS HARD CODED HERE ANYWAY IF THERE A DEPARTURE BOARD INDICATOR CONFIGURATION?!
        // if (Date.now() + (2000 * 60) >= departureDate) {
        //     this.fontcolor = "black"
        //     return "#ffff00";
        // }
        this.fontcolor = "black";
        return null;
    }
    //#endregion

    replaceEstimatedTimeIfEqualToTime(pDeparture: BoardEntry) {
        // if (pDeparture.time === pDeparture.timeProg)
        //     pDeparture.timeProg = null;
        return;
    }

}

export default DepartureBoardComponent;